import React from 'react';
import { Link } from 'react-router-dom';

import topViewDrone from '../../../main/assets/images/mrm2-10/top-view-drone.webp';

export const Integrate = () => (
  <section className="careprogram__section">
    <div className="careprogram__content--wrapper-mrm2">
      <div className="careprogram__box--wrapper-mrm responsive__padding">
        <div className="title__column--gap">
          <h2 className="dreamX__title">LEARN MORE</h2>
        </div>
        <p className="dreamX__body">
          If you need a trusted, ultra-reliable solution built for
          mission-critical integrations, you need the{' '}
          <span style={{ whiteSpace: 'nowrap' }}>MRM2-10.</span> Contact our
          team to discuss your exact operational requirements.
        </p>
        <div>
          <Link
            to="/contact?product=mrm2-10"
            rel="noopener noreferrer"
            className="btn btn--primary btn--med"
            onMouseDown={event => event.preventDefault()}
          >
            Contact Us
          </Link>
        </div>
        <div className="careprogram__image--wrapper">
          <img
            src={topViewDrone}
            alt="MRM2-10 Tactical Asset Without Payload"
            className="careprogram__image--mobile-mrm"
          />
        </div>
      </div>
    </div>
  </section>
);
